import numeral from 'numeral';
import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@mui/material';
import TaxBreakdown from '@src/components/checkout/tax-breakdown/tax-breakdown';

export const CostSummary = ({ price = {}, addOns = [] }) => {
    return (
    <>
        <div className='tw-flex tw-flex-col tw-p-[16px] tw-gap-[2px] tw-bg-[#E8F0FC]'>
            <div className='inputs tw-flex tw-flex-col tw-gap-[4px] tw-w-full'>
                <span className='tw-text-[16px] tw-leading-[24px] tw-font-[500]'>Quote</span>
                <div className='tw-flex tw-justify-between'>
                    <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px]'>Subtotal</span>
                    <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px] tw-font-[500]'>
                        {numeral(price.subTotal).format('$0,0.00')}
                    </span>
                </div>
                <div className='tw-flex tw-justify-between'>
                    <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px]'>
                        Service Protection Fee* (incl. taxes)
                    </span>
                    <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px] tw-font-[500]'>
                        {numeral(price.platformFees).format('$0,0.00')}
                    </span>
                </div>
                {price.processingFees > 0 && (
                    <div className='tw-flex tw-justify-between'>
                        <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px]'>
                            Processing Fees (incl. taxes)
                        </span>
                        <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px] tw-font-[500]'>
                            {numeral(price.processingFees).format('$0,0.00')}
                        </span>
                    </div>
                )}
                {addOns.length > 0 && (
                    <div className='tw-flex tw-flex-col tw-gap-[4px] tw-mt-[4px]'>
                        {(addOns || []).map(addOn => (
                            <div key={addOn.id} className='tw-flex tw-justify-between'>
                                <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px]'>
                                    {addOn.name}
                                </span>
                                <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px] tw-font-[500]'>
                                    {numeral(addOn.priceChange).format('$0,0.00')}
                                </span>
                            </div>
                        ))}
                    </div>
                )}

                {/* Tax Breakdown Component */}
                {price.taxes && <TaxBreakdown taxes={price.taxes} showDetails className='tw-mt-[4px]' />}
            </div>
            <Divider className='tw-w-full' />
            <div className='tw-flex tw-flex-col tw-items-end'>
                <span className='tw-text-[24px] tw-font-[700] tw-leading-[31px] tw-tracking-[0.46px] tw-uppercase'>
                    {numeral(price.total).format('$0,0.00')}
                </span>
                <span className='tw-text-[14px] tw-leading-[20.02px] tw-trackiing-[0.17px]'>Estimated Total Cost</span>
            </div>
        </div>
        <p className='tw-text-[12px] tw-leading-[16px] tw-text-[#5A5A5A] tw-mt-[8px]'>
            *Supports secure payments, customer support, and platform updates
        </p>
    </>
    );
};

CostSummary.propTypes = {
    price: PropTypes.shape({
        subTotal: PropTypes.number.isRequired,
        platformFees: PropTypes.number.isRequired,
        processingFees: PropTypes.number,
        gstAmount: PropTypes.number,
        pstAmount: PropTypes.number,
        totalTaxes: PropTypes.number,
        taxes: PropTypes.object,
        total: PropTypes.number.isRequired
    }).isRequired,
    addOns: PropTypes.array
};
